import React, {PropsWithChildren} from "react"
import WalletTermsFieldView from "./WalletTermsFieldView"
import WalletTermsFieldEdit from "./WalletTermsFieldEdit"
import {WalletTermsFieldProps} from "../types"
import {EditMode} from "../../../../resources/common"

export default function WalletTermsField({
	mode,
	type,
	name,
	subName,
	label,
	subLabel,
	value,
	subValue,
	onChange,
	onBlur,
	checked,
	inputType,
	children,
	inputPrefix,
	inputSuffix,
	inputFormat,
	infoIconTooltipText,
	enableField,
	...inputProps
}: PropsWithChildren<WalletTermsFieldProps>) {
	switch (mode) {
		case EditMode.VIEW:
			return (
				<WalletTermsFieldView
					label={label}
					subLabel={subLabel}
					value={value}
					subValue={subValue}
					inputFormat={inputFormat}
					inputPrefix={inputPrefix}
					inputSuffix={inputSuffix}
					infoIconTooltipText={infoIconTooltipText}
					enableField={enableField}
				/>
			)
		case EditMode.EDIT:
			return (
				<WalletTermsFieldEdit
					type={type}
					name={name}
					subName={subName}
					label={label}
					subLabel={subLabel}
					value={value}
					subValue={subValue}
					onChange={onChange}
					onBlur={onBlur}
					checked={checked}
					inputType={inputType}
					inputPrefix={inputPrefix}
					inputSuffix={inputSuffix}
					{...inputProps}
				>
					{children}
				</WalletTermsFieldEdit>
			)
	}

	return <></>
}
